import useMutation from "src/hooks/useMutation";

function useEmployeeCreate() {
  return useMutation({
    path: "/api/v1/users",
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/users`,
      shouldRevalidate: true,
    },
  });
}

export default useEmployeeCreate;
